import React from "react";
import { useGet, usePost } from "../hooks";
import { Goalie, Game } from "../interfaces";
import _ from "lodash";
import { SelectWithCustomOption } from "./SelectWithCustomOption";
import { getGoalieDisplayName, getGoalieDisplayNameWithSubLabel } from "../utils";

export function GoalieSelector(props: { gameId: string; teamId: string; showSubLabel?: boolean }) {
  const { gameId, teamId, showSubLabel } = props;

  const game = useGet<Game>(`/api/games?gameId=${gameId}`);
  const goalies = useGet<Goalie[]>("/api/goalies");
  const postReq = usePost({ uri: "/api/submitRoster", deps: [game] });

  let eligibleGoalies: Goalie[] = [];
  let curGoalieName: string | undefined = undefined;
  let otherGoalieId: number | undefined = undefined;
  if (game.data && goalies.data) {
    if (game.data.team1Id === _.toNumber(teamId)) {
      curGoalieName = game.data.team1GoalieName;
      otherGoalieId = game.data.team2Goalie;
    } else {
      curGoalieName = game.data.team2GoalieName;
      otherGoalieId = game.data.team1Goalie;
    }
    // Don't include the other team's goalie in the dropdown.
    eligibleGoalies = goalies.data.filter(
      (g: Goalie) => otherGoalieId !== g.id
    );
  }

  const getFullName = (g: Goalie) =>
    [g.firstName, g.lastName].filter(n => !!n).join(" ");
  const displayName = showSubLabel ? getGoalieDisplayNameWithSubLabel : getGoalieDisplayName;
  //sub (inactive this season) goalies appear after active goalies
  const sortedEligibleGoalies = [...eligibleGoalies].sort(
    (a, b) => Number(!!b.active) - Number(!!a.active)
  );
  const eligibleGoalieOptions = _.uniqBy(
    sortedEligibleGoalies.map(g => ({ label: displayName(g), value: getFullName(g) })),
    o => o.value
  );

  return (
    <>
      <SelectWithCustomOption
        initOptions={eligibleGoalieOptions}
        value={curGoalieName}
        onChange={(goalie: string) => {
          postReq.send({
            goalie,
            gameId,
            teamId,
            originalGoalieName: curGoalieName
          });
        }}
        loading={game.isLoading || goalies.isLoading || postReq.isLoading}
        style={{ width: 250 }}
      />
    </>
  );
}
